import script from "./AlertWerks.vue?vue&type=script&setup=true&name=AlertWerks&lang=js"
export * from "./AlertWerks.vue?vue&type=script&setup=true&name=AlertWerks&lang=js"

import "./AlertWerks.vue?vue&type=style&index=0&id=6f84363a&lang=css"

const __exports__ = script;

export default __exports__